var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";

import SubscriptionHeader from "../SubscriptionHeader";
import SubscriptionsList from "../SubscriptionsList";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import LatestStories from "../../../components/Library/LatestStories";

import { getSubscriptions } from "../../actions/subscriptions";

var Subscriptions = function (_Component) {
  _inherits(Subscriptions, _Component);

  function Subscriptions(props) {
    _classCallCheck(this, Subscriptions);

    return _possibleConstructorReturn(this, (Subscriptions.__proto__ || Object.getPrototypeOf(Subscriptions)).call(this, props));
  }

  _createClass(Subscriptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getSubscriptions({ subscription_type: "newsletter" });
    }
  }, {
    key: "render",
    value: function render() {
      var subscriptions = this.props.subscriptions;


      return React.createElement(
        Layout,
        { includeHeader: true, headerComponent: React.createElement(SubscriptionHeader, null) },
        React.createElement(
          Sidebar,
          null,
          React.createElement(LatestStories, null)
        ),
        React.createElement(
          Content,
          null,
          React.createElement(SubscriptionsList, { subscriptions: subscriptions })
        )
      );
    }
  }]);

  return Subscriptions;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    subscriptions: state.subscriptions
  };
};

export default connect(mapStateToProps, { getSubscriptions: getSubscriptions })(Subscriptions);


// WEBPACK FOOTER //
// ./src/subscriptions/components/Subscriptions/Subscriptions.js